const link = process.env.REACT_APP_SERVER_API_V2
const getLoginUrl = () => `${link}/login`

export default getLoginUrl;
